import React from 'react';
import { Loader2, ChevronRight } from 'lucide-react';
import type { Creation } from '../../types/create';

interface TransformationSuccessProps {
  currentTransformedImage: string | null;
  selectedCreation: Creation | undefined;
  onViewProducts: () => void;
}

export const TransformationSuccess: React.FC<TransformationSuccessProps> = ({
  currentTransformedImage,
  selectedCreation,
  onViewProducts
}) => {
  const displayImage = selectedCreation?.transformedImageUrl || currentTransformedImage;

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 flex flex-col items-center justify-center text-center py-8">
        <h2 className="text-2xl font-serif font-bold mb-6">Transformation Complete</h2>
        
        {displayImage ? (
          <div className="relative max-w-md w-full aspect-square rounded-xl overflow-hidden shadow-2xl mb-8 group">
            <img 
              src={displayImage} 
              alt="Transformed Masterpiece" 
              className="w-full h-full object-cover" 
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" />
          </div>
        ) : (
          <div className="w-64 h-64 bg-gray-100 rounded-xl flex items-center justify-center mb-8">
            <Loader2 className="w-8 h-8 animate-spin text-gray-400" />
          </div>
        )}

        <div className="max-w-md w-full">
          <button 
            onClick={onViewProducts}
            className="w-full bg-black text-white px-6 py-4 rounded-lg hover:bg-gray-800 transition-colors flex items-center justify-center gap-2 font-medium"
          >
            View Products
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

